import { useQuery, UseQueryOptions } from 'react-query';

type SubscriptionsResponse = {
  description: string;
  id: string;
  name: string;
  prices: {
    amount: number;
    currency: string;
    id: string;
    interval: 'month' | 'year';
  }[];
}[];

const subscriptionsQuery = (): UseQueryOptions<
  SubscriptionsResponse,
  Response | Error
> => ({
  queryKey: ['subscriptions'],
  queryFn: async () => {
    const response = await fetch('/api/v1/subscriptions/products');

    if (response.ok) {
      return await response.json();
    } else {
      throw response;
    }
  },
  retry: 0,
});

export const useSubscriptions = () => {
  return useQuery(subscriptionsQuery());
};
